import {METADATA, PAN_POSITIONS, SIDE_POSITIONS} from "../../constants";
import AccessoryCommon from "./accessoryCommon";
// import {Shower} from "../../parts/shower";

export default class GrabBar extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'grab_bar';
    this.partName = 'Grab Bar';
    this.translateId = "visualizer.bathroom.accessories.grab_bar";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {
        [PAN_POSITIONS[0]]: null,
        [PAN_POSITIONS[1]]: null,
        [PAN_POSITIONS[2]]: null,
      };
    }
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Shower"]) {
      dbFeature.metaData["Shower"] = ["Shower"];
    }
    if (dbFeature.sharedFeatureName === "24in - Studio - CH - WIT") {
      dbFeature.metaData["Shower"] = [METADATA.ALL];
    }
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : METADATA.LeftSide;
    const partNumber = dbFeature.metaData["layerPosition"] === PAN_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new GrabBar(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  disabledClick() {
    if (!this.disabled && this.activeFeature) {
      this.activeFeature.handleClick() // check soapDish
    }
  }

  availableFeatures(features) {
    return features.filter(feature => feature.partNumber === 1)
  }

  handleClick(ignoreLocked) { // "this" is feature!! not the feature group
    super.handleClick(ignoreLocked);
    // const parent = this.getParent();
    // const accessoriesParent = parent.getParent();
    // const showerParent = accessoriesParent.layout.parts[Shower.id];
    // const showerSize = showerParent.showerSize();
    // if (showerSize !== "60" && parent.activeFeature) {
    //   parent.layerPositions[parent.activeFeature.metaData["layerPosition"]] = parent.activeFeature;
    // }
    // parent.checkRelatedFeatureGroupPositions(this.metaData["layerPosition"]);
  }

  checkCurrentPositions(position) {
    const feature = this.layerPositions[position];
    if (!feature) {
      return
    }
    const nameSplitted = feature.dbFeature.sharedFeatureName.split(" ");
    const size = nameSplitted[nameSplitted.length - 1] ? nameSplitted[nameSplitted.length - 1].replace("in", "") : "";
    const newPosition = position === SIDE_POSITIONS[0] ? SIDE_POSITIONS[1] : SIDE_POSITIONS[0];
    if (!size || !this.layerPositions[newPosition]) {
      return
    }
    if (this.layerPositions[newPosition]) {
      const nameSplitted2 = this.layerPositions[newPosition].dbFeature.sharedFeatureName.split(" ");
      const size2 = nameSplitted2[nameSplitted2.length - 1] ? nameSplitted2[nameSplitted2.length - 1].replace("in", "") : "";
      if (!size || (+size2 === 12 && +size === 12)) { // last chance to keep other side layer
        return;
      }
    }
    this.layerPositions[newPosition] = null;
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      if (this.layerPositions["C"]) {
        this.layerPositions["C"].layer.zIndex = zIndexes.Accessories.GrabBar
      }
      if (this.layerPositions["L"]) {
        this.layerPositions["L"].layer.zIndex = zIndexes.Accessories.GrabBar + 10
      }
      if (this.layerPositions["R"]) {
        this.layerPositions["R"].layer.zIndex = zIndexes.Accessories.GrabBar + 20
      }
    }
  }

  // showLayerPositionsModal() {
  //   const showerParent = this.getParent().layout.parts[Shower.id];
  //   return showerParent.showerSize() === "60"
  // }

}
